// With apologies to other Chromium-based browsers that actually GIVE DEVELOPERS WHAT THEY WANT!
const iAmABrowserDevelopedBySimiansPerchedOnAnIvoryTowerWithNoGraspOfReality =
	typeof window != 'undefined' && typeof (window as any).chrome != 'undefined' && !(window.navigator as any).brave;

// Common password manager ignore attributes:
//   Bitwarden:  data-bwignore="true"
//   LastPass:   data-lpignore="true"
//   1Password:  data-1p-ignore (presence suffices)
// Exported separately for advanced use-cases; prefer disableBrowserAutofill() for merging inputProps.
export const PASSWORD_MANAGER_IGNORE_INPUT_PROPS = {
	'data-bwignore': 'true',
	'data-lpignore': 'true',
	'data-1p-ignore': 'true'
} as const;

/**
 * Returns MUI TextField props that disable browser autocomplete and suppress password managers.
 * Pass any existing `inputProps` and they will be merged — password-manager attributes always take
 * precedence to ensure they are never accidentally clobbered by a caller spread.
 */
export function disableBrowserAutofill<T extends object>(inputProps?: T) {
	return {
		/*
        As of Sept 2020 (https://stackoverflow.com/questions/15738259/disabling-chrome-autofill):
		Update May 2023: Edge/Chrome respects autocomplete=chrome-off, Brave respects autocomplete=off

        Until the next forced browser update breaks this once more ...
        */
		autoComplete: 'off' as const,
		inputProps: {
			...inputProps,
			...PASSWORD_MANAGER_IGNORE_INPUT_PROPS
		}
	};
}

/** Convenience alias for components that have no additional `inputProps` to merge. */
export const DISABLE_BROWSER_AUTOFILL_SETTINGS = disableBrowserAutofill();

export const DISABLE_BROWSER_AUTOFILL_SELECT_SETTINGS = {
	inputProps: {
		autoComplete: 'off',
		...PASSWORD_MANAGER_IGNORE_INPUT_PROPS
	}
} as const;
